import { pageAccess } from '../../security/LoginDetail.js';

const PopulateNavLink = () =>
{    
    let navLinks = []; 

    if (pageAccess === null) return;

    pageAccess.map((d) => {
        if (navLinks[d.ParentId] === undefined){
            navLinks[d.ParentId] = {
                icon: 'pe-7s-id',
                label : d.ParentName,
                content: []
            }
        }
        navLinks[d.ParentId].content.push({ label : d.PageName, to : '/' + d.ParentName.toLowerCase() +  '/' + d.PageUrl });
    });

    return navLinks;
};

export const ComponentsMasterNav = PopulateNavLink();

// export const ComponentsMasterNav = [
//     {
//         icon: 'pe-7s-id',
//         label: 'Master',
//         content: [
//             {
//                 label: 'User',
//                 to: '/mst-user',
//             },
//             {
//                 label: 'Role',
//                 to: '/mst-role',
//             },
//             {
//                 label: 'Layout',
//                 to: '/mst-layout',
//             },
//         ],
//     }
// ];


// export const ComponentsNav = [
//     {
//         icon: 'pe-7s-diamond',
//         label: 'Elements',
//         content: [
//             {
//                 label: 'Standard Buttons',
//                 to: '/elements/buttons-standard',
//             },
//             {
//                 label: 'Dropdowns',
//                 to: '/elements/dropdowns',

//             },
//             {
//                 label: 'Icons',
//                 to: '/elements/icons',
//             },
//             {
//                 label: 'Badges',
//                 to: '/elements/badges-labels',
//             },
//             {
//                 label: 'Cards',
//                 to: '/elements/cards',
//             },
//             {
//                 label: 'List Groups',
//                 to: '/elements/list-group',
//             },
//             {
//                 label: 'Navigation Menus',
//                 to: '/elements/navigation',
//             },
//             {
//                 label: 'Utilities',
//                 to: '/elements/utilities',
//             },
//         ],
//     },
//     {
//         icon: 'pe-7s-car',
//         label: 'Components',
//         content: [
//             {
//                 label: 'Tabs',
//                 to: '/components/tabs',
//             },
//             {
//                 label: 'Notifications',
//                 to: '/components/notifications',
//             },
//             {
//                 label: 'Modals',
//                 to: '/components/modals',
//             },
//             {
//                 label: 'Progress Bar',
//                 to: '/components/progress-bar',
//             },
//             {
//                 label: 'Tooltips & Popovers',
//                 to: '/components/tooltips-popovers',
//             },
//             {
//                 label: 'Carousel',
//                 to: '/components/carousel',
//             },
//             {
//                 label: 'Maps',
//                 to: '/components/maps',
//             },
//         ],
//     },
//     {
//         icon: 'pe-7s-display2',
//         label: 'Regular Tables',
//         to: '/tables/regular-tables',
//     },
// ];